import React, { useState } from 'react';
import { Container, Row, Col, Card, CardHeader, CardBody, Button, Alert, Spinner } from 'reactstrap';
import { AiOutlineFileText, AiOutlineDownload } from 'react-icons/ai';
import { apiGenerarInformeAPE } from '../../utils/APIs/APISResume';

const InformeAPE = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);

    const generarInforme = async () => {
        setLoading(true);
        setError(null);
        setSuccess(false);
        setDownloadUrl(null);

        try {
            const result = await apiGenerarInformeAPE({ data: {} });

            if (result && result.result && result.result.status === 'INFORME_EXPORTAD0') {
                setSuccess(true);
                setDownloadUrl(result.result.data);
                
                // Abrir la URL de descarga en una nueva pestaña
                window.open(result.result.data, '_blank');
            } else {
                setError('Error al generar el informe: Respuesta inesperada del servidor');
                console.error('Respuesta inesperada:', result);
            }
        } catch (err) {
            setError('Error de conexión al generar el informe');
            console.error('Error:', err);
        } finally {
            setLoading(false);
        }
    };

        return (
        <Container fluid>
            <Row>
                <Col>
                    <Card className="mt-4">
                        <CardHeader>
                            <h4 className="mb-0">
                                <AiOutlineFileText className="mr-2" />
                                Generar Informe APE
                            </h4>
                        </CardHeader>
                        <CardBody>
                            <p className="text-muted">
                                Este proceso generará un archivo Excel con el informe APE y lo descargará automáticamente.
                            </p>
                            
                            {error && (
                                <Alert variant="danger" className="mb-3">
                                    {error}
                                </Alert>
                            )}
                            
                            {success && (
                                <Alert variant="success" className="mb-3">
                                    ¡Informe generado exitosamente! La descarga se inició automáticamente.
                                </Alert>
                            )}
                            
                            <Button 
                                variant="primary" 
                                onClick={generarInforme}
                                disabled={loading}
                                className="d-flex align-items-center"
                            >
                                {loading ? (
                                    <>
                                        <div className="d-flex align-items-center">
                                            <div className="spinner-border spinner-border-sm mr-2" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                            <span>Generando informe...</span>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <AiOutlineDownload className="mr-2" />
                                        Generar Informe APE
                                    </>
                                )}
                            </Button>
                            
                            {downloadUrl && (
                                <div className="mt-3">
                                    <small className="text-muted">
                                        Si la descarga no se inició automáticamente, puedes hacer clic en el enlace:
                                    </small>
                                    <br />
                                    <a 
                                        href={downloadUrl} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="btn btn-sm btn-outline-primary mt-2"
                                        style={{
                                            color: 'orange', 
                                            borderColor: 'orange',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.backgroundColor = 'orange';
                                            e.target.style.color = 'white';
                                            e.target.style.borderColor = 'orange';
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.backgroundColor = 'transparent';
                                            e.target.style.color = 'orange';
                                            e.target.style.borderColor = 'orange';
                                        }}
                                    >
                                        <AiOutlineDownload className="mr-1" />
                                        Forzar la descarga
                                    </a>
                                </div>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            
            {/* Footer */}
            <Row className="mt-5">
                <Col className="text-center">
                    <div className="page-title-subheading">
                        Sysconfi - Confipetrol &#169; {new Date().getFullYear()}
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default InformeAPE; 